
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M26.906 11.406a2.906 2.906 0 11-5.812 0 2.906 2.906 0 015.812 0zM24 33.688a2.906 2.906 0 100 5.812 2.906 2.906 0 000-5.813zm12.594-12.594a2.906 2.906 0 100 5.812 2.906 2.906 0 000-5.812zM14.312 24A2.906 2.906 0 108.5 24a2.906 2.906 0 005.813 0zm.783 5.999a2.906 2.906 0 100 5.812 2.906 2.906 0 000-5.812zm17.81 0a2.906 2.906 0 100 5.812 2.906 2.906 0 000-5.812zm-17.81-17.81a2.906 2.906 0 100 5.812 2.906 2.906 0 000-5.812z","fill":"#535353"}})])
          )
        }
      }
    